import { Room } from './getRooms'


export const URL = '/v2/pms/accomodations/:id/rooms/'

export type Req = {
  room_category: number
  number: number
  floor: number
  notes: string
}[]

export type Resp = Room[]
